import { render, staticRenderFns } from "./cms-block-spacer.vue?vue&type=template&id=3902a296&scoped=true"
import script from "./cms-block-spacer.vue?vue&type=script&lang=js"
export * from "./cms-block-spacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902a296",
  null
  
)

export default component.exports